/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSequencerDevicesRequest = {
  agentId: string;
};

/** @internal */
export const GetSequencerDevicesRequest$inboundSchema: z.ZodType<
  GetSequencerDevicesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type GetSequencerDevicesRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const GetSequencerDevicesRequest$outboundSchema: z.ZodType<
  GetSequencerDevicesRequest$Outbound,
  z.ZodTypeDef,
  GetSequencerDevicesRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getSequencerDevicesRequestToJSON(
  getSequencerDevicesRequest: GetSequencerDevicesRequest,
): string {
  return JSON.stringify(
    GetSequencerDevicesRequest$outboundSchema.parse(getSequencerDevicesRequest),
  );
}
export function getSequencerDevicesRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSequencerDevicesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSequencerDevicesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSequencerDevicesRequest' from JSON`,
  );
}
